import Slider from '../slider';

export default () => {
  const slider = new Slider({
    wrapper: '.environment-wrapper',
    slide: '.environment-slide',
    btnNext: '.environment-btn--next',
    btnPrev: '.environment-btn--prev',
    infinite: false,
    disableBtnClass: 'environment-btn--disabled',
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/environment/index.js